const validationMessage = {
  required: "This field is required*",
  email: "Please enter a valid email id",
  phoneNo: "Please enter a valid Contact Number",
  number: "Please enter a number",
  abhyasiIdPattern: "Please enter valid Abhyasi ID"
};

const validations = {

  required: {
    value: true,
    message: validationMessage.required
  },

  email: {
    value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i,
    message: validationMessage.email
  },

  phoneNo: {
    value: /^[0-9]{10,14}$/,
    message: validationMessage.phoneNo
  },

  userName: {
    value: /^(?![\s.]+$)[a-zA-Z\s]*$/,
    message: validationMessage.userName
  },

  number: {
    value: /^\d+$/,
    message: validationMessage.number
  },

  abhyasiId: {
    value: /^([a-zA-Z]{6}[0-9]{3}|[HABhab]{1}[0-9]{8})$/,
    message: validationMessage.abhyasiIdPattern
  }

};


export {
  validations,
  validationMessage
}